export default "__VITE_ASSET__BKChjIrE__"